import { authRoles } from "app/auth";

const navigationConfig = [
	{
		id: "applications",
		title: "Staff 메뉴",
		type: "group",
		icon: "apps",
		auth: authRoles.staff,
		children: [
			// {
			// 	id: "dashboards",
			// 	title: "대시보드",
			// 	type: "collapse",
			// 	icon: "dashboard",
			// 	children: [
			// 		{
			// 			id: "analytics-dashboard",
			// 			title: "Analytics",
			// 			type: "item",
			// 			url: "/apps/dashboards/analytics",
			// 		},
			// 		{
			// 			id: "project-dashboard",
			// 			title: "Project",
			// 			type: "item",
			// 			url: "/apps/dashboards/project",
			// 		},
			// 	],
			// },
			{
				id: "dashboards",
				title: "통계",
				type: "item",
				icon: "dashboard",
				url: "/apps/dashboards/analytics",
			},
			{
				id: "user",
				title: "사용자 관리",
				type: "item",
				icon: "people",
				url: "/Users",
			},
			{
				id: "game",
				title: "규칙 설정 ",
				type: "item",
				icon: "settings",
				auth: authRoles.staff,
				url: "/game",
			},
			// {
			// 	id: "banner",
			// 	title: "배너 관리",
			// 	type: "collapse",
			// 	icon: "image",
			// 	auth: authRoles.staff,
			// 	url: "/banner",
			// 	children: [
			// 		{
			// 			id: "banners",
			// 			title: "배너 리스트",
			// 			type: "item",
			// 			url: "/banner",
			// 			exact: true,
			// 		},
			// 		{
			// 			id: "banner-new",
			// 			title: "배너 등록",
			// 			type: "item",
			// 			url: "/banner/new",
			// 			exact: true,
			// 		},
			// 	],
			// },
			{
				id: "withDraw",
				title: "인출 관리",
				type: "item",
				icon: "money_off",
				url: "/Withdraw",
			},
			{
				id: "etc",
				title: "점검 관리",
				type: "item",
				icon: "build",
				url: "/etc",
			},
			// {
			// 	id: "game",
			// 	title: "게임 관리",
			// 	type: "item",
			// 	icon: "gamepad",
			// 	url: "/game",
			// },
			// {
			// 	id: "banner",
			// 	title: "배너 관리",
			// 	type: "item",
			// 	icon: "image",
			// 	url: "/banner",
			// },
		],
	},

	{
		type: "divider",
		id: "divider-1",
		auth: authRoles.admin,
	},
	{
		id: "adminUser",
		title: "최고관리자 메뉴",
		type: "group",
		icon: "apps",
		auth: authRoles.admin,
		children: [
			{
				id: "adminUser",
				title: "관리자 권한부여",
				type: "item",
				url: "/Admin",
				icon: "security",
				auth: authRoles.admin,
			},
		],
	},
];

export default navigationConfig;
